import { QueryOptionsData } from "@myvp/shared/src/types"
import { queryOptions } from "@tanstack/react-query"
import {
  GetParticipantEventsAndGroupsInput,
  GetSurveyFilterOptionsInput,
  ListUserSurveySummariesInput,
  SurveyFilter,
} from "src/gql/graphql"
import * as real from "src/pages/study/participants/participants.service"
import * as mock from "src/pages/study/participants/participants.mock"
import { selectService } from "@myvp/shared/src/functions/mock"

const service =
  process.env.REACT_APP_release === "true"
    ? real
    : selectService({ mock, real })

export type EventsAndGroupsData = QueryOptionsData<
  typeof getParticipantEventsAndGroupsQueryOptions
>

export const getParticipantEventsAndGroupsQueryOptions = (
  args: GetParticipantEventsAndGroupsInput
) =>
  queryOptions({
    queryKey: ["getParticipantEventsAndGroups", args.studyParticipantId],
    queryFn: () =>
      service.getParticipantEventsAndGroups({
        studyParticipantId: args.studyParticipantId,
      }),
  })

export type UserSurveySummaries = QueryOptionsData<
  typeof listUserSurveySummariesForSponsorOptions
>["userSurveySummaries"]

export const listCriteriaCheckEventLogsForSponsorOptions = (args: {
  criteriaCheckEventId: string
  siteUserLanguage: string
}) => {
  return queryOptions({
    queryKey: ["listCriteriaCheckEventLogsForSponsor", args],
    queryFn: () => service.listCriteriaCheckEventLogsForSponsor(args),
  })
}

export type ListCriteriaCheckEventLogsForSponsor = QueryOptionsData<
  typeof listCriteriaCheckEventLogsForSponsorOptions
>

export type ClientSurveyFilter = Omit<
  SurveyFilter,
  "signatureStatuses" | "surveyLocations"
> & {
  signatureStatuses: NonNullable<SurveyFilter["signatureStatuses"]>
}

export const listUserSurveySummariesForSponsorOptions = (
  args: ListUserSurveySummariesInput
) => {
  return queryOptions({
    queryKey: ["listUserSurveySummariesForSponsor", args],
    queryFn: () => service.listUserSurveySummariesForSponsor(args),
  })
}

export type AvailableFilters = QueryOptionsData<
  typeof getSurveyFilterOptionsForSponsor
>

export const getSurveyFilterOptionsForSponsor = (
  args: GetSurveyFilterOptionsInput
) => {
  return queryOptions({
    queryKey: ["getSurveyFilterOptionsForSponsor", args],
    queryFn: () => service.getSurveyFilterOptionsForSponsor(args),
  })
}
